'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var TextArea = require('@narvar/nth-block-text-area');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TextArea__default = /*#__PURE__*/_interopDefaultLegacy(TextArea);

const StyledTextarea = styled__default["default"](TextArea__default["default"]).withConfig({
  componentId: "sc-1re6i3t-0"
})(["width:100%;min-height:200px;display:flex;"]);

exports.StyledTextarea = StyledTextarea;
